// react
import { ChangeEvent } from 'react';

// types
import { EntityPayload, UserPayload } from '../../../../@types';

// i18n
import { TFunction } from 'i18next';

// mui
import { Checkbox, Grid, InputLabel } from '@mui/material';

// table
import { TableHeader } from '../../../ui/Table/Table';

// props
export interface GetHeadersParams {
	entity: EntityPayload;
	isChecked?: boolean;
	isDisabled?: boolean;
	onChangeAllUsers?: (entity: EntityPayload, checked: boolean) => void;
	onChangeUser?: (
		e: ChangeEvent<HTMLInputElement>,
		checked: boolean,
		user: UserPayload,
		entity: EntityPayload
	) => void;
	selectedUserIds?: Set<string>;
	t: TFunction<'translation', undefined>;
	users: UserPayload[];
}

export const getHeaders = ({
	entity,
	isChecked,
	isDisabled,
	onChangeAllUsers,
	onChangeUser,
	selectedUserIds,
	t,
	users,
}: GetHeadersParams): TableHeader[] => {
	return [
		{
			CheckboxProps: {
				checked:
					Boolean(users?.length) &&
					users?.every((user) => (selectedUserIds || new Set<string>()).has(String(user.idWbg))),
				disabled: !isChecked || isDisabled,
				onChange: (e: ChangeEvent<HTMLInputElement>, checked: boolean) => {
					onChangeAllUsers?.(entity, checked);
				},
			},
			label: t('name'),
			render: (firstName: string, header: TableHeader, user: UserPayload) => {
				const userId = String(user.idWbg || '');
				const checkboxId = `entity-${entity.idWbg}-user-${userId}`;
				const isUserSelected = selectedUserIds ? selectedUserIds.has(userId) : false;

				return (
					<Grid alignItems="center" container spacing={1}>
						<Grid item xs="auto">
							<Checkbox
								checked={isUserSelected}
								disabled={isDisabled || !isChecked}
								disableRipple={true}
								id={checkboxId}
								name={checkboxId}
								onChange={(e, checked) => {
									if (onChangeUser && userId) {
										onChangeUser(e, checked, user, entity);
									}
								}}
								sx={{
									padding: 0,
								}}
								value={userId}
							/>
						</Grid>
						<Grid item xs={true}>
							<InputLabel
								disabled={isDisabled}
								htmlFor={checkboxId}
								sx={{
									margin: 0,
									whiteSpace: 'normal',
								}}>
								{user.firstName} {user.lastName}
							</InputLabel>
						</Grid>
					</Grid>
				);
			},
			value: 'firstName',
		},
		{
			label: t('email'),
			value: 'email',
		},
	];
};
